module.exports = __webpack_public_path__ + "img/table2.aebaf6b4.jpg";